<template>
  <div class="plv-ia-notice__url">
    <div class="plv-ia-notice__url__content">
      <div class="plv-ia-notice__url__header">
        <span></span>
        <i @click="tapCancel">&times;</i>
      </div>
      <div class="plv-ia-notice__url__body">
        <div class="plv-ia-notice__url__row">
          <label>{{ t('plvIA.notice.linkAddr') }}</label>
          <input
            v-model="linkUrl"
            type="text"
            autofocus
          />
        </div>
        <div class="plv-ia-notice__url__row">
          <label>{{ t('plvIA.notice.linkTxt') }}</label>
          <input
            v-model="linkTxt"
            type="text"
            :placeholder="t('plvIA.notice.defaultLinkAddr')"
          />
        </div>
      </div>
      <div class="plv-ia-notice__url__fotter">
        <button class="plv-ia-btn-new plv-ia-btn-blue" :disabled="!linkUrl.length" @click="tapAdd">{{ link ? t('plvIA.notice.edit') : t('plvIA.notice.add') }}</button>
        <button class="plv-ia-btn-new plv-ia-btn-cancel" @click="tapCancel">{{ t('plvIA.common.cancel') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import Locale from '@/mixins/locale';
export default {
  name: 'NoticeUrl',
  mixins: [Locale],
  props: {
    link: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      linkUrl: (this.link && this.link.linkUrl) || '',
      linkTxt: (this.link && this.link.linkTxt) || ''
    };
  },
  methods: {
    tapAdd() {
      const linkUrl = this.addProtocol(this.linkUrl);
      const linkTxt = this.linkTxt || linkUrl;
      this.$emit('tap-add', {
        linkUrl: encodeURI(linkUrl),
        linkTxt,
        isEdit: !!this.link
      });
    },
    tapCancel() {
      this.$emit('tap-cancel');
    },
    addProtocol(str) {
      if (!/^http(s?):\/\//.test(str)) {
        return 'http://' + str.replace(/^\/\//, '');
      }
      return str;
    }
  }
};
</script>;

<style lang="scss" scoped>
$imgPrefix: './images/';

.plv-ia-notice__url {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
}
.plv-ia-notice__url__content {
  background: #fff;
  width: 420px;
  height: 280px;
  border-radius: 4px;
}

.plv-ia-notice__url__header {
  height: 48px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 0 20px 0 16px;

  span {
    display: inline-block;
    width: 32px;
    height: 48px;
    background: url($imgPrefix + 'btn-link.png') no-repeat;
    background-position: center;
    background-size: 32px;
  }

  i {
    color: #90a4ae;
    float: right;
    font-style: normal;
    font-size: 20px;
    line-height: 48px;
    user-select: none;
    cursor: pointer;
  }
}

.plv-ia-notice__url__body {
  padding: 40px 24px;
}

.plv-ia-notice__url__row {
  margin-top: 24px;
  display: flex;
  align-items: center;

  &:first-child {
    margin-top: 0;
  }

  label {
    color: #999;
    margin-right: 16px;
    line-height: 32px;
  }

  input {
    width: 300px;
    box-sizing: border-box;
    line-height: 30px;
    padding: 0 16px;
    border: 1px solid #D8D8D8;
    outline: none;

    &::-webkit-input-placeholder {
      color: #999;
    }

    &:focus {
      border-color: #2196F3;
    }
  }
}

.plv-ia-notice__url__fotter {
  display: flex;
  justify-content: center;

  button {
    margin: 0 8px;
  }
}

</style>
